// extracted by mini-css-extract-plugin
export default {"gray":"TransactionResultPage_gray__hluQL","black":"TransactionResultPage_black__sK62x"};